<script>
    export let videos = [];
    export let title = '';

    export let classes = "pl-lg-4"
</script>

<div class="{classes}">
    <h5 class="p-0 m-0 mb-2 font-weight-bold">{title}</h5>
    <ul class="list-unstyled p-0 m-0 flex-wrap">
        {#each videos as video}
            {#if video.video}
                <li class="mb-3">
                    <a href="{video.video}" target="_blank">{video.video}</a>
                </li>
            {/if}
        {/each}
    </ul>
</div>
